import React from "react";

function LogsTable({ logs, backendUrl, setActiveLog }) {
  return (
    <div style={{ paddingBottom: "50px" }} className="mt-5 overflow-x-auto">
      <h4>Past Logs</h4>
      <div style={{ maxHeight: "500px" }} className="overflow-auto">
        <table className="table overflow-y-auto table-striped table-bordered mt-2">
          <thead className="table-light">
            <tr>
              <th>Label</th>
              <th>Prompt</th>
              <th>Timestamp</th>
              <th>Tokens</th>
              <th>Cost</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {logs.length > 0 ? (
              logs.map((log, idx) => {
                const label = (log.filename || "").split("_Final_Report")[0];
                return (
                  <tr key={idx}>
                    <td>{label}</td>
                    <td>{log.prompt_name || "—"}</td>
                    <td>{log.timestamp || "—"}</td>
                    <td>{log.tokens_used || "—"}</td>
                    <td>${(log.tokens_used * 0.000015).toFixed(4)}</td>
                    <td>
                      <button
                        className="btn btn-sm"
                        onClick={() =>
                          setActiveLog({
                            ...log,
                            viewUrl: `${backendUrl}/api/view_page/?log_id=${log.id}`,
                          })
                        }
                        style={{
                          backgroundColor: "#fd7e14",
                          color: "white",
                          fontWeight: 600,
                          borderRadius: "0.5rem",
                          padding: "6px 12px",
                        }}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={6}>No logs yet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default LogsTable;
